
import Qrcode from 'vux/src/components/qrcode/index.vue'


export default {
name: 'coupon',
components: {
},
data () {
return {
list:[],
}
},
created(){
this.communityCoupon();
},
mounted(){



},
methods:{
communityCoupon(){
this.$api.communityCoupon({}).then((res)=>{
if(res){
this.list = res.data;
}
})
},
give(id){
this.$router.push({name:'giveCoupon',params:{id:id}});
},
qrCoupon(id){
this.$router.push({name:'qrCoupon',params:{id:id}});
},
}
}



// WEBPACK FOOTER //
// ./src/pages/coupon.vue